import { Action } from '@ngrx/store';
import { StatedData } from './stated-data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function statedDataToAction<
  T,
  Actions extends {
    success: (data: T) => Action;
    failure: (error: any) => Action;
    loading: () => Action;
  },
>(statedDataStream: Observable<StatedData<T>>, actions: Actions): Observable<Action> {
  return statedDataStream.pipe(
    map(statedData => {
      if (statedData.isLoading) {
        return actions.loading();
      } else if (statedData.hasError) {
        return actions.failure(statedData.error);
      } else {
        return actions.success(statedData.result as T);
      }
    }),
  );
}
